import { EChartOption } from "echarts";

type Bar = {
  category_1: string;
  num_profiles: number;
  num_rare_profiles: number;
  num_developmental_profiles: number;
  num_top_profiles: number;
  num_roles: number;
};

export const supplyTotalDemandChartConfig = (
  title: string,
  bar: Bar[],
  showBy: string,
  seriesNames: string[]
): EChartOption => ({
  tooltip: {
    show: true,
    trigger: "axis",
    axisPointer: {
      type: "shadow"
    },
    formatter: (params) => {
      const name = params?.[0]?.name || params?.[1]?.name;
      const values = bar.find((data) => data.category_1 === name);
      const markerColor = params[0].marker.match(/#[a-z0-9]{6}/gi);
      const lines: string[] = [];
      lines.push(params[0].name);
      if (params[0]) {
        lines.push(`${params[0].marker} ${params[0].seriesName}: ${params[0].value}`);
      }
      if (params[1]) {
        lines.push(`${params[1].marker} ${params[1].seriesName}: ${params[1].value}`);
      }
      lines.push(
        `${params[0].marker.replace(markerColor, "#fac858")} ${seriesNames[1]}: ${
          values?.num_rare_profiles || 0
        }`
      );
      lines.push(
        `${params[0].marker.replace(markerColor, "#ee6666")} ${seriesNames[2]}: ${
          values?.num_developmental_profiles || 0
        }`
      );
      lines.push(
        `${params[0].marker.replace(markerColor, "#73c0de")} ${seriesNames[3]}: ${
          values?.num_top_profiles || 0
        }`
      );

      return lines.join("<br />");
    }
  },
  toolbox: {
    show: true,
    right: 20,
    feature: {
      saveAsImage: {
        title: title,
        backgroundColor: "transparent"
      }
    }
  },
  legend: {
    orient: "vertical",
    right: 70
  },
  xAxis: {
    type: "category",
    data: bar.map((data) => data[showBy]),
    axisLabel: {
      interval: 0,
      rotate: 50
    }
  },
  yAxis: {
    type: "value"
  },
  grid: {
    left: 100,
    right: 50,
    bottom: 50,
    containLabel: true
  },
  series: [
    {
      name: seriesNames[0],
      type: "bar",
      data: bar.map((data) => data.num_profiles),
      emphasis: {
        itemStyle: {
          shadowBlur: 10,
          shadowOffsetX: 0,
          shadowColor: "rgba(0, 0, 0, 0.2)"
        }
      }
    },
    {
      name: seriesNames[4],
      type: "bar",
      data: bar.map((data) => data.num_roles),
      emphasis: {
        itemStyle: {
          shadowBlur: 10,
          shadowOffsetX: 0,
          shadowColor: "rgba(0, 0, 0, 0.2)"
        }
      }
    }
  ]
});
